import { notification } from 'antd'
import { useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType, UpdateDriverData } from '@types'

import { DriversApi } from './api'

const useUpdateDriver = () => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_update_driver.'

  const queryClient = useQueryClient()

  const onUpdateSuccess = () => {
    queryClient.invalidateQueries([QUERY_KEYS.DRIVERS, QUERY_KEYS.USER])
  }

  const updateDriver = async (driverId: number, updatedData: UpdateDriverData) => {
    try {
      await DriversApi.updateDriver(driverId, updatedData)
      onUpdateSuccess()
      notification.success({
        message: t('The_modification_was_made_successfully'),
      })
    } catch (error) {
      const axiosError = error as AxiosErrorType

      if (axiosError && axiosError.data && axiosError.data.error) {
        const errorResponse = axiosError.data.error
        const { type, message } = errorResponse

        if (type === 'SOME_ERROR_TYPE') {
          const hint =
            message.length > 62
              ? `${t(`${tPreffix}no_active_route_hint`)} ${message.substring(62)}`
              : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

          notification.error({
            message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
          })
        } else {
          notification.error({
            message: t('The_modification_was_not_made'),
          })
        }
      } else {
        console.error('Error:', axiosError)
      }
    }
  }

  return {
    updateDriver,
  }
}

export { useUpdateDriver }

// TODO: Multicarriers Advances
